<template>
  <!-- Enterprise Pricing -->
    <v-switch
      v-model="company.affiliation_enabled"
      :label="$t('screener.admin.company.affiliation_feature_enabled.label')"
      color="saPrimary"
    >
      <template v-slot:append>
        <v-tooltip top color="white">
          <template v-slot:activator="{on}">
            <v-icon v-on="on">mdi-information-outline</v-icon>
          </template>
          <div class="greyDarken3--text body-1">
            {{$t('screener.admin.company.affiliation_feature_enabled.tooltip')}}
          </div>
        </v-tooltip>
      </template>
    </v-switch>
</template>

<script>
export default {
name: 'AdminCompanyProfileAffiliation',
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  watch: {
    company: {
      handler: function() {
        this.$emit('update:company', this.company);
      },
      deep: true,
    },
  },
}
</script>

<style>

</style>
